"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CraniometricsTab = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ListTabContent_1 = require("../ListTabContent");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
function CraniometricsTab({ onResize }) {
    return ((0, jsx_runtime_1.jsx)(ListTabContent_1.ListTabContent, { onResize: onResize, type: bridge_schema_1.InfoBoxTabType.Craniometrics, "data-e2e": 'CraniometricsTab_ListTabContent' }));
}
exports.CraniometricsTab = CraniometricsTab;
